import setUpTradePage from '../../src/trade_page/trade'

import(/* webpackChunkName: "carousels" */ '../../src/carousels').then(module => {
  module.default()
  module.initTradePageCarousel()
})

document.addEventListener('DOMContentLoaded', () => setUpTradePage())
